import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import FormCheckbox from 'components/common/searchfilter/FormCheckbox';

import { CONNECT_ABUSING_COMMUNITY, CONNECT_ABUSING_PAYMENT } from 'constants/member/connect';

import { ConnectCommunityUserStatus, ConnectUserStatus } from 'types/member';
import { memberDetailActions } from 'features/member/reducer/memberDetailSlice';

interface Props {
  userId: string;
  status: ConnectUserStatus;
  communityStatus: ConnectCommunityUserStatus;
}

const AbusingUserCheckbox = ({ userId, status, communityStatus }: Props) => {
  const dispatch = useDispatch();

  const [checkedAbusingUserStatus, setCheckedAbusingUserStatus] = useState<boolean>(
    status === ConnectUserStatus.INACTIVE,
  );

  const [checkedAbusingCommunityStatus, setCheckedAbusingCommunityStatus] = useState<boolean>(
    communityStatus === ConnectCommunityUserStatus.INACTIVE,
  );

  const onChangeStatus = (_event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const connectUserStatus = checkedAbusingUserStatus
      ? ConnectUserStatus.ACTIVE
      : ConnectUserStatus.INACTIVE;

    setCheckedAbusingUserStatus(!checkedAbusingUserStatus);
    dispatch(memberDetailActions.updateConnectUserStatus({ userId, status: connectUserStatus }));
  };

  const onChangeCommunityStatus = (
    _event: React.ChangeEvent<{ name?: string; value: unknown }>,
  ) => {
    const connectCommunityStatus = checkedAbusingCommunityStatus
      ? ConnectCommunityUserStatus.ACTIVE
      : ConnectCommunityUserStatus.INACTIVE;

    setCheckedAbusingCommunityStatus(!checkedAbusingCommunityStatus);
    dispatch(
      memberDetailActions.updateConnectCommunityUserStatus({
        userId,
        status: connectCommunityStatus,
      }),
    );
  };

  return (
    <>
      <FormCheckbox
        label="Payment"
        value={CONNECT_ABUSING_PAYMENT}
        checked={checkedAbusingUserStatus}
        onChange={onChangeStatus}
      />
      <FormCheckbox
        label="Community"
        value={CONNECT_ABUSING_COMMUNITY}
        checked={checkedAbusingCommunityStatus}
        onChange={onChangeCommunityStatus}
      />
    </>
  );
};

export default AbusingUserCheckbox;
